module.exports = __webpack_public_path__ + "static/media/four-hole-flat.708cfa84.webp";